import { render } from "./dwc_contactDetails.vue?vue&type=template&id=49d828f8&scoped=true"
import script from "./dwc_contactDetails.vue?vue&type=script&lang=js"
export * from "./dwc_contactDetails.vue?vue&type=script&lang=js"

import "./dwc_contactDetails.vue?vue&type=style&index=0&id=49d828f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49d828f8"]])

export default __exports__